module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "subject"
    }
  }, [_c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Daftar Mata Pelajaran")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.subjects), function(subject) {
    return _c('div', {
      key: subject.id,
      staticClass: "col-md-4 col-sm-12"
    }, [_c('div', {
      staticClass: "widget widget-stats",
      class: _vm.bgColor(subject.id)
    }, [_c('div', {
      staticClass: "stats-icon"
    }, [_c('img', {
      staticStyle: {
        "max-width": "80px"
      },
      attrs: {
        "src": subject.picture,
        "alt": "subject-logo"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "stats-info"
    }, [_c('h4', [_vm._v("Kode: " + _vm._s(subject.code))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(subject.name))])]), _vm._v(" "), _c('div', {
      staticClass: "stats-link"
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: '/topic-management/detail',
          query: {
            subject_id: subject.id
          }
        }
      }
    }, [_vm._v("Lihat Bab "), _c('i', {
      staticClass: "fa fa-arrow-circle-o-right"
    })])], 1)])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25a59792","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/kodifikasi/TopicManagement.vue
// module id = 1306
// module chunks = 0